import React, { useState, useRef, useEffect } from "react";
import Modal from "../../components/Modal/Modal";
import ApiManager from "../../ApiManager/ApiManager";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import "./FuelCard.css";

const statusColors = {
  approved: "approved",
  rejected: "rejected",
  pending: "pending",
  created: "created",
  default: ""
};

const PettyCashCard = ({ pettyCash }) => {
  const [expanded, setExpanded] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const status = (pettyCash.status || "default").toLowerCase();

  // For smooth animation
  const bodyRef = useRef(null);
  const [bodyHeight, setBodyHeight] = useState(0);

  useEffect(() => {
    if (expanded && bodyRef.current) {
      setBodyHeight(bodyRef.current.scrollHeight);
    } else {
      setBodyHeight(0);
    }
  }, [expanded]);

  const handleReceiptClick = async (e) => {
    e.stopPropagation();
    if (!pettyCash.filepath) return;
    setShowFile(true);
    setLoadingFile(true);
    setFileUrl(null);
    setFileType(null);
    try {
      const query = new URLSearchParams({ file_name: pettyCash.filepath });
      const response = await ApiManager.getFile(query);
      if (!response.ok) throw new Error("Failed to fetch file");
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const mimeType = response.headers.get("Content-Type");
      setFileUrl(url);
      setFileType(mimeType);
    } catch (error) {
      setFileUrl(null);
      setFileType(null);
    }
    setLoadingFile(false);
  };

  return (
    <div className={`fuel-card${expanded ? " expanded" : ""}`}>
      {/* Accordion Header */}
      <div
        className={`fuel-card-header${expanded ? " expanded" : ""}`}
        onClick={() => setExpanded((e) => !e)}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <span className="fuel-card-type">
            {pettyCash.type || "Petty Cash"}
          </span>
          <span className="fuel-card-date">
            {pettyCash.created_at
              ? new Date(pettyCash.created_at).toLocaleString('en-GB', {
                  day: '2-digit',
                  month: '2-digit', 
                  year: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
                  timeZone: 'Asia/Kolkata'
                }).replace(',', '')
              : "No Date"}
          </span>
          <span className="fuel-card-amount">
            ₹{pettyCash.amount}
          </span>
        </div>
        <span className="fuel-card-arrow">{expanded ? "⌃" : "⌄"}</span>
      </div>
      {/* Accordion Body with smooth transition */}
      <div
        className="fuel-card-body"
        style={{
          maxHeight: expanded ? bodyHeight : 0,
          opacity: expanded ? 1 : 0
        }}
      >
        <div ref={bodyRef} className="fuel-card-body-inner">
          <div style={{ marginBottom: 8 }}>
            <b>Description:</b> {pettyCash.description}
          </div>
          <div style={{ marginBottom: 8 }}>
            <b>Car:</b> {pettyCash.car_number || pettyCash.car_id}
          </div>
          <div style={{ marginBottom: 8 }}>
            <b>Driver:</b> {pettyCash.driver_name || pettyCash.driver_id}
          </div>
          {pettyCash.filepath && (
            <button
              className="custom-button"
              onClick={handleReceiptClick}
            >
              View Receipt
            </button>
          )}
          {showFile && (
            <Modal isOpen={showFile} onClose={() => setShowFile(false)} title="Petty Cash Receipt">
              {loadingFile ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                  <LoadingSpinner message="Loading file..." />
                </div>
              ) : fileUrl ? (
                fileType === "application/pdf" ? (
                  <iframe src={fileUrl} width="100%" height="500px" title="Petty Cash Receipt PDF"></iframe>
                ) : (
                  <img
                    src={fileUrl}
                    alt="Petty Cash Receipt"
                    style={{ maxWidth: "100%", objectFit: "contain", display: "block", margin: "auto" }}
                  />
                )
              ) : (
                <p>Loading file...</p>
              )}
            </Modal>
          )}
        </div>
      </div>
    </div>
  );
};

export default PettyCashCard; 